import React, {useContext} from 'react';
import concat from 'lodash/concat';
import compact from 'lodash/compact';

import {Select} from 'components';
import * as utils from 'utils';

import styles from './FilterProducts.module.scss';
import Context from '../../../../context';
import {reducerFilters} from '../../../../reducers';
import {sortByName} from '../../../../helpers';

export const FilterProducts = () => {
  const {
    data,
    loading,
    filters: {products},
    dispatchFilters,
  } = useContext(Context);

  const productsForFilter = data.map(item => item.filterProducts);
  const arrOptions = compact([...new Set(concat(...productsForFilter))]);
  const sortedOptions = sortByName(arrOptions);
  const options = sortedOptions.map(label => ({
    value: `products--${label}`,
    label,
  }));

  const handleChange = values => {
    // Tracking Analytics
    const items = values.map(item => item.label).join(', ');
    utils.handleAnalytics('dropdown', 'products', items);

    dispatchFilters({
      type: reducerFilters.actionTypes.updateProducts,
      payload: values || [],
    });
  };

  return (
    <Select
      className={styles.wrap}
      multiple
      placeholder="All Products"
      controlAmountText="products"
      value={products}
      options={options}
      loading={loading}
      onChange={handleChange}
    />
  );
};

FilterProducts.defaultProps = {};

FilterProducts.propTypes = {};
